import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import RenderIf from '../../../shared/render-if/components/render-if';
import CommissionSchemeAffiliate from './commission-scheme-affiliate';
import registerConstants from '../../register/constants/register-constants';
import CommissionSchemeNonAffiliate from './commission-scheme-non-affiliate';

class CommissionScheme extends Component {
  render() {
    const { profile } = this.props;

    return (
      <div className="commission-scheme-container">
        <RenderIf if={profile}>
          <div className="row">
            <RenderIf if={profile && profile.user_type === registerConstants.user_types.affiliate}>
              <div className="col-md-12">
                <CommissionSchemeAffiliate profile={profile} />
              </div>
            </RenderIf>
            <RenderIf if={profile && profile.user_type !== registerConstants.user_types.affiliate}>
              <div className="col-md-12">
                <CommissionSchemeNonAffiliate profile={profile} />
              </div>
            </RenderIf>
          </div>
        </RenderIf>
        <RenderIf if={!profile}>
          <DefaultLoader />
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.userProfileReducer.profile,
  promotions: state.commissionSchemeReducer.promotions,
});

const mapDispatchToProps = dispatch => ({});

CommissionScheme.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CommissionScheme);



// WEBPACK FOOTER //
// ./src/app/main/commission-scheme/components/commission-scheme.js